module.exports = __webpack_public_path__ + "img/tel.d4059013.png";